<template>
  <v-container fluid grid-list-md>
    <progress-bar></progress-bar>
    <v-toolbar class="mb-4">
      <v-btn icon :to="projects">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class='caption'>
        <span class="title"><strong>{{ project.name }}</strong><br></span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card class="mt-3">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <div class='sl_form_title'>
              <h3>Time log</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-menu v-model="dropDowns.from" :return-value="reports.time.form.from" lazy transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      v-model="reports.time.form.from"
                      label="From"
                      v-on="on"
                      outline
                    />
                  </template>
                  <v-date-picker locale="ua-ua" :first-day-of-week="1" v-model="reports.time.form.from" no-title scrollable></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4>
                <v-menu v-model="dropDowns.to" :return-value="reports.time.form.to" lazy transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      v-model="reports.time.form.to"
                      label="To"
                      v-on="on"
                      outline
                    />
                  </template>
                  <v-date-picker locale="ua-ua" :first-day-of-week="1" v-model="reports.time.form.to" no-title scrollable></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm2>
                <v-btn large color="info" block @click="getTimeReport">Get</v-btn>
              </v-flex>
              <v-flex xs12 sm2>
                <v-btn large color="success" block @click="exportTimeReport">Export</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-text>
        <v-data-table :headers="reports.time.headers" hide-actions :items="reports.time.data">
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ format(props.item.created_at) }}</td>
              <td class="text-xs-left">{{ props.item.user.name }}</td>
              <td class="text-xs-center">
                <div class="tasks_page__list--item_chip">
                  <router-link
                    target="_blank"
                    :to="{name: 'tasks-form', params: {project_id: props.item.task.project_id, task_id: props.item.task.id}}"
                  >
                    {{ props.item.task.short_name.toUpperCase() }}
                  </router-link>
                </div>
              </td>
              <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="text-xs-center">{{ props.item.duration }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'
  import moment from 'moment'
  import {mapGetters} from 'vuex'

  export default {
    name: 'ProjectReports',
    mixins: [mixins.preloader],
    data() {
      return {
        dropDowns: {
          from: false,
          to: false
        },
        project_id: this.$route.params.project_id,
        project: {},
        reports: {
          time: {
            headers: [
              {text: 'Date', align: 'center', sortable: false, value: 'created_at', width: "150"},
              {text: 'Employee', align: 'left', sortable: false, width: "180"},
              {text: 'Task', align: 'center', sortable: false},
              {text: 'Track description', align: 'left', sortable: false},
              {text: 'Time', align: 'center', sortable: false, width: "100"},
            ],
            data: [],
            form: {
              from: moment().subtract(7, 'days').format("YYYY-MM-DD"),
              to: moment().add(1, 'day').format("YYYY-MM-DD"),
            }
          },
        },
      }
    },
    computed: mapGetters(["projects"]),
    methods: {
      format(date) {
        return moment(date).format("DD.MM.YYYY HH:mm")
      },
      exportTimeReport() {
        let params = this.collectParams()

        this.$api.times.export(params)
      },
      getTimeReport() {
        let params = this.collectParams()

        this.$api.times.list(params).then(({data}) => {
          this.reports.time.data = data
        })
      },
      collectParams() {
        return {
          unlimit: 1,
          projects: [this.project_id],
          approved: true,
          order: 'created_at',
          direction: 'desc',
          ...this.reports.time.form
        }
      }
    },
    mounted() {
      this.$api.projects.get(this.project_id).then(({data}) => {
        this.project = data
      })
    }
  }
</script>
